export default __webpack_public_path__ + "static/media/SCANIA_VENTAJAS_COMPETITIVAS_DE_UN_CAMION_SCANIA.a1b1b9ac.pdf";